import {
    preparePublicKeyCreationOptions,
    preparePublicKeyRequestOptions,
    serializeAssertionResponse,
    serializeAttestationResponse,
} from './webauthnUtils';

export const isPasskeySupported = async () => {
    if (typeof window === 'undefined') return false;
    const credentialApi = window.PublicKeyCredential;
    if (!credentialApi || !navigator.credentials) return false;
    if (typeof credentialApi.isUserVerifyingPlatformAuthenticatorAvailable === 'function') {
        try {
            return await credentialApi.isUserVerifyingPlatformAuthenticatorAvailable();
        } catch (error) {
            return false;
        }
    }
    return true;
};

export const registerPasskey = async (client) => {
    const { data } = await client.post('/auth/passkey/register/options');
    const publicKey = preparePublicKeyCreationOptions(data);
    const credential = await navigator.credentials.create({ publicKey });

    if (!credential) {
        throw new Error('Passkey registration was cancelled.');
    }

    const payload = serializeAttestationResponse(credential);
    return client.post('/auth/passkey/register/verify', payload);
};

export const loginWithPasskey = async (client, identifier) => {
    const payload = identifier ? { identifier } : undefined;
    const { data } = await client.post('/auth/passkey/login/options', payload);
    const publicKey = preparePublicKeyRequestOptions(data);
    const credential = await navigator.credentials.get({ publicKey });

    if (!credential) {
        throw new Error('Passkey login was cancelled.');
    }

    const assertion = serializeAssertionResponse(credential);
    return client.post('/auth/passkey/login/verify', assertion);
};
